import type { MerchantDataPayload } from '@repo/api/endpoints/merchant';
import {
  AgreementsNames,
  agreementsNames,
  LiberisAgreementsNames,
  PrefixedAgreementsNames,
  providerType,
} from '@repo/shared/types';
import { hasProviderAnyLoanFinished } from '@repo/store/helpers';

const regularPragmaAgreements = [
  agreementsNames.enum['representative'],
  agreementsNames.enum['loanTerms'],
  agreementsNames.enum['payProDataProcessing'],
  agreementsNames.enum['pragmaGoDataProcessing'],
  agreementsNames.enum['professionalContract'],
];

const noLoanPragmaAgreements = [
  agreementsNames.enum['pragmaTerms'],
  agreementsNames.enum['bikbig'],
  agreementsNames.enum['marketing'],
];

const liberisAgreements = [
  'agreements.bureau',
  'agreements.liberisMarketing',
  'agreements.payProToLiberisData',
  'agreements.liberisDataToPayPro',
] as LiberisAgreementsNames[];

export const getCurrentAgreements = ({
  data,
  isLiberisAgreements,
  isPragmaMultiprovider,
}: {
  data: MerchantDataPayload;
  isLiberisAgreements?: boolean;
  isPragmaMultiprovider?: boolean;
}) => {
  if (isLiberisAgreements) {
    return liberisAgreements;
  }

  let agreementNames: (AgreementsNames | PrefixedAgreementsNames | LiberisAgreementsNames)[] =
    isPragmaMultiprovider
      ? [
          ...regularPragmaAgreements.map(
            (agreement) => `pragmaAgreements.${agreement}` as PrefixedAgreementsNames,
          ),
          ...noLoanPragmaAgreements.map(
            (agreement) => `pragmaAgreements.${agreement}` as PrefixedAgreementsNames,
          ),
        ]
      : [...regularPragmaAgreements];

  if (!hasProviderAnyLoanFinished(providerType.enum.pragma, data)) {
    agreementNames.push(...noLoanPragmaAgreements);
  }

  return agreementNames;
};

export const isAgreementFieldVisible = (
  agreementName: AgreementsNames,
  data: MerchantDataPayload,
) => getCurrentAgreements({ data }).includes(agreementName);
